import { FC } from "react"

interface NoTableDataProps {
    label: string
    className?: string
}

export const NoTableData: FC<NoTableDataProps> = ({ label, className }) => {
    return (
        <div className={["info_panel text-lg", className].filter(Boolean).join(' ')}>
            {label}
        </div>
    )
}